import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import TemplatesSection from './components/TemplatesSection';
import TestimonialsSection from './components/TestimonialsSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { siteConfig } from '@/mocks/site';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="WebSite"
        data={{
          name: siteConfig.siteName,
          url: siteConfig.siteUrl,
          description: siteConfig.siteDescription,
          inLanguage: siteConfig.locale,
        }}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: siteConfig.siteName,
          url: siteConfig.siteUrl,
          description: siteConfig.siteDescription,
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${siteConfig.siteName} - 首页`,
          description: siteConfig.siteDescription,
          url: siteConfig.siteUrl,
          isPartOf: { '@id': `${siteConfig.siteUrl}/#website` },
          about: { '@id': `${siteConfig.siteUrl}/#organization` },
        }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturesSection />
        <HowItWorksSection />
        <TemplatesSection />
        <TestimonialsSection />
        <PricingSection />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}